import Layout from '../../components/Layout/Layout';

const TestPageV2 = () => {
  return (
    <Layout>
      <h1>Page principale des tests (V2)</h1>
    </Layout>
  );
};

export default TestPageV2; 